import React, { useState } from 'react';
import ActivityLoader from '../../Common/ActivityLoader';
import BsModal from '../../Common/BsModal';
import { useTheme } from '../../../DataStore/ThemeContext';
import Notification from '../../Common/Notification';
import ajaxReport from '../../../util/remote/ajaxReport';
import { useReport } from '../../../DataStore/ReportContext';

const AlertRemoveComment = () => {

    const [loading, setLoading] = useState(false);
    const {setNotify} = useTheme();

    const { setRemoveComment, removeComment } = useReport();

    const handleClose = () => setRemoveComment({ show: false, comment: null });


   if (!removeComment.comment) return null;
  
   

    const confirm = async()=>{
        setLoading(true);
        const server_response = await ajaxReport.deleteReportCommentField(removeComment.comment.id);
        setLoading(false);
        if(server_response.status === "OK"){
            removeComment.callback();
            setNotify(<Notification type='success' message={server_response.message}/>)
        }else{
            setNotify(<Notification type='danger' message={server_response.message}/>)

        }
        handleClose();
    }

    return (
        <BsModal
            show={removeComment.show}
            onClose={handleClose}
            title="Remove Comment Field"
            footer={
                <>
                    {loading && <ActivityLoader />}
                    {!loading && <>
                    <button className="btn btn-secondary" onClick={handleClose}>
                        Cancel
                    </button>
                    <button className="btn btn-danger" onClick={confirm}>
                        Confirm
                    </button>
                    </>}
                </>
            }
        >


            {removeComment.comment && <div className="d-flex justify-content-center align-items-center flex-column">
                <i 
                className="fa fa-question-circle text-danger" 
                style={{ fontSize: "40px", lineHeight: "1", marginTop: "20px" }}
                ></i>
                <h5 className='mt-1 text-dark text-center' style={{fontSize: '17px'}}>Please confirm that you want to remove <i>{removeComment.comment.comment.title}</i> field from the selected academic reports.</h5>

        
           
            </div>}
          

        </BsModal>
    );
};

export default AlertRemoveComment;
